import styled from "styled-components";
import { Theme } from "theme";
import { StatTableTd } from "../styles";

export const StatCell = styled(StatTableTd)`
  font-size: 0;
`;

export const Stat = styled.span`
  font-size: 12pt;
  @media (max-width: 1000px) {
    font-size: 11pt;
  }
`;

export const StatBreakdown = styled.span`
  font-size: 10pt;
  color: gray;
  @media (max-width: 1000px) {
    font-size: 9.5pt;
  }
`;

export const Time = styled.span`
  font-size: 11.5pt;

  @media (max-width: 1000px) {
    font-size: 10pt;
  }
`;
